function Error(props: any): JSX.Element {
	return <div>Error</div>;
}

export default Error;
